document.addEventListener('DOMContentLoaded', function () {
  const sizeBox = document.querySelector('.build-box-main');
  const boxNotify = document.querySelector('.box-full');
    const cartFree = parseInt(document.querySelector('.totals__subtotal-value').getAttribute('cart-value'), 10);
   const cartItems = document.querySelectorAll('.cart-item');
    const freeBoxElement = document.querySelector('.box-count-main-free');
  const freeBoxconfity = document.querySelector('.cstm-confity');
   const boxSample = document.querySelector('.free-sample');
  const BuildHeader = document.querySelectorAll('.box-count-main');
  const variantsCta = document.querySelectorAll('.product-varaints-cta');
  const buildFinalPdpImages = document.querySelectorAll('.build-final-pdp-image');
  const buildFinalSpan = document.querySelectorAll('.build-final-span');
  const buildRemoveSpan = document.querySelectorAll('.remove-build');
  const buildRemoveSelect = document.querySelectorAll('.box-stored-select');
  const buildRemoveOutline = document.querySelectorAll('.box-stored-pd');
  const buildBoxCta = document.querySelector('.cta-build-box');
  const buildFooterCta = document.querySelector('.cta-build-footer');
  const assortdCta = document.querySelectorAll('.product-varaints-assorted');
  const assortCross = document.querySelectorAll('.assorted-pop-cross');
  const assortInnerCta = document.querySelectorAll('.assorted-variant-cta');
  const assortedQtyBox = document.querySelectorAll('.quantity-cstm-assorted .quantity__button');
  const finalPrice = document.querySelector('.final-build-mrp');
  const totalPrice = document.querySelector('.total-build-box');
  const savePriceQ = document.querySelector('.save-price');
  const totalPriceValue = parseInt(totalPrice.getAttribute('total-build-price').replace(/,/g, '')) || 0;
  const sizeBuck = sizeBox?.getAttribute('size-box') || 0;
    let totalBuildPrice = parseInt(localStorage.getItem('totalBuildPrice')) || 0;
    const updateFinalPrice = () => {
      const priceElement = document.querySelector('.final-build-mrp');
      if (priceElement) {
        if (totalBuildPrice === 0) {
      priceElement.style.display = 'none';  
    } else {
      priceElement.textContent = totalBuildPrice.toFixed(2);
      priceElement.style.display = 'block'; 
    }
      }
    };
  function setupConfetti(triggerSelector, containerSelector) {
  let confettiTriggered = false;
  function observeTrigger() {
    const observer = new MutationObserver(() => {
      if (shouldTriggerConfetti()) {
        launchConfetti();
        confettiTriggered = true;
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  function shouldTriggerConfetti() {
    const triggerElement = document.querySelector(triggerSelector);
    return triggerElement && !confettiTriggered;
  }
  function launchConfetti() {
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.error(`Container not found for selector: ${containerSelector}`);
      return;
    }
    const canvas = document.createElement("canvas");
    container.appendChild(canvas);
    const myConfetti = confetti.create(canvas, { resize: true });
    myConfetti({
      particleCount: 2000,
      spread: 200,
      origin: { y: 0.45 },
    });
    setTimeout(() => {
      canvas.remove();
    }, 8000);
  }
  observeTrigger();
}
   function updateSavePrice(totalBuildPrice, totalPriceValue) {
    const diffPrice = document.querySelector('.save-price');
      if (!diffPrice) return;
      const difference = totalBuildPrice - totalPriceValue;
      console.log('Difference (totalBuildPrice > totalPriceValue):', difference.toFixed(2));
     const totalCartPrice = totalBuildPrice + cartFree;
     console.log('totalCartPrice',totalCartPrice);
      const boxCartLength = JSON.parse(localStorage.getItem('selectedVariants'));
       if (totalBuildPrice >= 1899 && boxCartLength.length === 4) {
          // boxSample.classList.remove('d-none');
         // freeBoxElement.ClassList.remove('d-none');
        //  const freeBoxId = freeBoxElement.getAttribute('free-box-id');
        // const freeBoxImg = freeBoxElement.getAttribute('fre-box-img');
        //  if (freeBoxElement != undefined || freeBoxElement != null ) {
        //    freeBoxElement.classList.remove('d-none');
        //  }
        //  if (!localStorage.getItem('freeBox')) {
        //    freeBoxconfity.classList.remove('d-none');
        //   setTimeout(() => {
        //       freeBoxconfity.classList.add('d-none');
        //   }, 3000); 
        //   setupConfetti(".over-progress", ".cstm-confity");
        //   const freeBox = [
        // { id: freeBoxId, image: freeBoxImg, quantity: 1 }
        // ];
        //    localStorage.setItem('freeBox', JSON.stringify(freeBox));
        //  } 
       }    
      else {
        // boxSample.classList.add('d-none');
         //  if (freeBoxElement != undefined || freeBoxElement != null ) {
         //   freeBoxElement.classList.add('d-none');
         // }
       localStorage.removeItem('freeBox');
      }
      if (totalBuildPrice > totalPriceValue) {
        diffPrice.classList.remove('d-none');
        diffPrice.textContent = 'Save : ₹' + difference.toFixed(2);
      } else {
        diffPrice.classList.add('d-none');
      }
    }
  let selectedVariants = JSON.parse(localStorage.getItem('selectedVariants')) || [];
   let selectedAssortedVariants = JSON.parse(localStorage.getItem('selectedAssortedVariants')) || [];
   const updateBuildBoxId = () => {
      const allVariants = [
        ...selectedVariants.map(variant => ({
          id: variant.id,
          quantity: variant.quantity || 1,
        })),
        ...selectedAssortedVariants.map(variant => ({
          id: variant.id,
          quantity: variant.quantity || 1,
        }))
      ];
      if (buildBoxCta) {
        buildBoxCta.setAttribute('build-box-id', JSON.stringify(allVariants));
      }
    }
    buildFinalPdpImages?.forEach((imageElement, index) => {
      if (selectedVariants[index]) {
        imageElement.setAttribute("src", selectedVariants[index].image);
        imageElement.classList.remove('d-none');
      } else {
        imageElement.classList.add('d-none');
      }
    });
    BuildHeader?.forEach((spanElement, index) => {
      const removeBtn = spanElement?.querySelector('.remove-build');
      if (selectedVariants[index]) {
        spanElement.setAttribute("remove-build-id", selectedVariants[index].id);
        spanElement.setAttribute("remove-build-img", selectedVariants[index].image);
        removeBtn?.classList.remove('d-none');
      } else {
        spanElement.removeAttribute("remove-build-id");
        spanElement.removeAttribute("remove-build-img");
        removeBtn?.classList.add('d-none');
      }
    });
    buildFinalSpan?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('d-none');
      } else {
        spanElement.classList.remove('d-none');
      }
    });
   buildRemoveSelect?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('d-none');
      } else {
        spanElement.classList.remove('d-none');
      }
    });
    buildRemoveOutline?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('show-bord');
      } else {
        spanElement.classList.remove('show-bord');
      }
    });
    variantsCta?.forEach((evt) => {
      evt.addEventListener('click', function () {
        console.log('selectedVariants',selectedVariants.length);
        if (selectedVariants.length >= sizeBuck) {
          if (boxNotify) {
            boxNotify.classList.remove('d-none');
            setTimeout(() => boxNotify.classList.add('d-none'), 3000);
          }
          return;
        }
        const thisId = this.getAttribute('variant-build-id');
        const thisImage = this.getAttribute('build-variant-image');
        const thisQuantity = parseInt(this.getAttribute('add-quantity')) || 1;
        const thisPrice = parseInt(this.getAttribute('data-price-build'));
        if (!thisId || !thisImage) return;
          selectedVariants.push({ id: thisId, image: thisImage, quantity: thisQuantity, price: thisPrice });
          localStorage.setItem('selectedVariants', JSON.stringify(selectedVariants));
           let totalBuildPrice = parseFloat(localStorage.getItem('totalBuildPrice')) || 0;
           totalBuildPrice += thisPrice;
          localStorage.setItem('totalBuildPrice', totalBuildPrice);
         const priceElement = document.querySelector('.final-build-mrp');
          if (priceElement) {
            if (totalBuildPrice === 0) {
                priceElement.style.display = 'none';  
              } else {
                priceElement.textContent = totalBuildPrice.toFixed(2);
                priceElement.style.display = 'block'; 
              }
            }
       updateSavePrice(totalBuildPrice, totalPriceValue);
        const cardParent = this.closest('.box-prod-content');
        if (cardParent) {
          cardParent.classList.add('card-added');
        }
  
        buildFinalPdpImages?.forEach((imageElement, index) => {
          if (selectedVariants[index]) {
            imageElement.setAttribute("src", selectedVariants[index].image);
            imageElement.classList.remove('d-none');
          } else {
            imageElement.classList.add('d-none');
          }
        });
  
        buildFinalSpan?.forEach((spanElement, index) => {
          if (selectedVariants[index]) {
            spanElement.classList.add('d-none');
          } else {
            spanElement.classList.remove('d-none');
          }
        });
         buildRemoveSelect?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('d-none');
      } else {
        spanElement.classList.remove('d-none');
      }
    });
            buildRemoveOutline?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('show-bord');
      } else {
        spanElement.classList.remove('show-bord');
      }
    });
  
        BuildHeader?.forEach((spanElement, index) => {
          const removeBtn = spanElement?.querySelector('.remove-build');
          if (selectedVariants[index]) {
            spanElement.setAttribute("remove-build-id", selectedVariants[index].id);
            spanElement.setAttribute("remove-build-img", selectedVariants[index].image);
            removeBtn?.classList.remove('d-none');
          } else {
            spanElement.removeAttribute("remove-build-id");
            spanElement.removeAttribute("remove-build-img");
            removeBtn?.classList.add('d-none');
          }
        });
  
        updateBuildBoxId();
      });
    });
    BuildHeader?.forEach((spanElement) => {
      spanElement.addEventListener('click', function () {
        const removeId = this.getAttribute('remove-build-id');
        const removeAssortId = this.getAttribute('remove-assort-id');
        if (!removeId) return;
        const removeIndex = selectedVariants.findIndex(variant => variant.id === removeId);
           const removeAssortIds = removeAssortId ? removeAssortId.split(',') : [];
        if (removeIndex !== -1) {
        let totalBuildPrice = parseFloat(localStorage.getItem('totalBuildPrice')) || 0;
        const variantPrice = selectedVariants[removeIndex]?.price || 0;
        totalBuildPrice = Math.max(0, totalBuildPrice - variantPrice);
        localStorage.setItem('totalBuildPrice', totalBuildPrice);
          selectedVariants.splice(removeIndex, 1);
          localStorage.setItem('selectedVariants', JSON.stringify(selectedVariants));
            const priceElement = document.querySelector('.final-build-mrp');
              if (priceElement) {
                if (totalBuildPrice === 0) {
              priceElement.style.display = 'none';  
            } else {
              priceElement.textContent = totalBuildPrice.toFixed(2);
              priceElement.style.display = 'block'; 
            }
              }
     updateSavePrice(totalBuildPrice, totalPriceValue);
          variantsCta?.forEach((evt) => {
            const thisId = evt.getAttribute('variant-build-id');
            const cardParent = evt.closest('.box-prod-content');
            if (thisId === removeId && cardParent) {
              cardParent.classList.remove('card-added');
            }
          });
          buildFinalPdpImages?.forEach((imageElement, index) => {
            if (selectedVariants[index]) {
              imageElement.setAttribute("src", selectedVariants[index].image);
              imageElement.classList.remove('d-none');
            } else {
              imageElement.classList.add('d-none');
            }
          });
          buildFinalSpan?.forEach((spanElement, index) => {
            if (selectedVariants[index]) {
              spanElement.classList.add('d-none');
            } else {
              spanElement.classList.remove('d-none');
            }
          });
           buildRemoveSelect?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('d-none');
      } else {
        spanElement.classList.remove('d-none');
      }
    });
              buildRemoveOutline?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('show-bord');
      } else {
        spanElement.classList.remove('show-bord');
      }
    });
          BuildHeader?.forEach((spanElement, index) => {
            const removeBtn = spanElement?.querySelector('.remove-build');
            if (selectedVariants[index]) {
              spanElement.setAttribute("remove-build-id", selectedVariants[index].id);
              spanElement.setAttribute("remove-build-img", selectedVariants[index].image);
              removeBtn?.classList.remove('d-none');
            } else {
              spanElement.removeAttribute("remove-build-id");
              spanElement.removeAttribute("remove-build-img");
              removeBtn?.classList.add('d-none');
            }
          });
         removeAssortIds.forEach((id, index) => {
        const removeAssortIndex = selectedAssortedVariants.findIndex(variant => variant.id === id);
        if (removeAssortIndex !== -1) {
          selectedAssortedVariants.splice(removeAssortIndex, 1);
          localStorage.setItem('selectedAssortedVariants', JSON.stringify(selectedAssortedVariants));
        }
      });
          //  selectedAssortedVariants.splice(removeAssortIndex, 1);
          // localStorage.setItem('selectedAssortedVariants', JSON.stringify(selectedAssortedVariants));
             updateBuildBoxId();  
        }
      });
    });
//  assorted
     let idQuantityArray = [];
    assortdCta?.forEach((ev) => {
      ev.addEventListener('click', function() {
        const popup = this.closest('.assorted-card').querySelector('.assorted-popup');
        console.log('popup',popup);
        if (popup) {
          popup.classList.remove('d-none');
          document.body.classList.add('overflow-cart-hidden');
        }
      });
    });
   assortCross?.forEach((ev) => {
        ev.addEventListener('click', function() {
          const popupClose = this.closest('.assorted-card').querySelector('.assorted-popup');
           const popupAtc = popupClose.querySelector('.assorted-variant-cta');
          if (popupClose) {
            console.log('popupAtc',popupAtc);
            popupClose.classList.add('d-none');
            document.body.classList.remove('overflow-cart-hidden');
                idQuantityArray = [];
                const quantityInputs = popupClose.querySelectorAll('.quantity__input-cstm-assorted');
                quantityInputs.forEach((input, index) => {
                  if (index === 0) {
                    input.value = 1;
                  } else {
                    input.value = 0;
                  }
                });
              popupClose.querySelectorAll('.quantity__input-cstm-assorted').forEach((input) => {
                const inputId = input.getAttribute('data-id');
                const inputValue = parseInt(input.value || 0);
                if (inputValue > 0) {
                  idQuantityArray.push({ id: inputId, quantity: inputValue });
                }
              });
            if (popupAtc) {
              popupAtc.setAttribute('pop-array-id','')
            }
          }
        });
      });
   assortInnerCta?.forEach((evt) => {
  evt.addEventListener('click', function () {
    const parentPopup = this.closest('.assorted-popup');
    const assortErr = parentPopup.querySelector('.assorted-err');
    const restrictSize = this.getAttribute('assort-size');
    console.log('assort-size',restrictSize);
    let totalQuantity = idQuantityArray.reduce((sum, item) => sum + item.quantity, 0);
    console.log('totalQuantity', totalQuantity);
    if (totalQuantity < parseInt(restrictSize)) {
      if (assortErr) {
        assortErr.classList.remove('d-none');
        setTimeout(() => assortErr.classList.add('d-none'), 3000);
      }
      return;
    }
    if (selectedVariants.length >= sizeBuck) {
      if (boxNotify) {
        boxNotify.classList.remove('d-none');
        setTimeout(() => boxNotify.classList.add('d-none'), 3000);
      }
      return;
    }

    const thisId = this.getAttribute('pop-cta-id');
    const thisImage = this.getAttribute('assorted-variant-image');
    const thisPrice = parseFloat(this.getAttribute('assort-prices')) || 0;
    const thisQuantity = parseInt(this.getAttribute('add-quantity')) || 1;
    const assortedArray = JSON.parse(this.getAttribute('pop-array-id'));
    console.log('assortedArray', assortedArray);
    if (assortedArray.length > 0) {
      const firstVariant = assortedArray[0];
      selectedVariants.push({ id: firstVariant.id, image: thisImage, quantity: thisQuantity, price: thisPrice });
      const remainingVariants = assortedArray.slice(1);
      selectedAssortedVariants.push(...remainingVariants);

      localStorage.setItem('selectedVariants', JSON.stringify(selectedVariants));
      localStorage.setItem('selectedAssortedVariants', JSON.stringify(selectedAssortedVariants));
    }
    console.log('thisPrice',thisPrice);
    let totalBuildPrice = parseFloat(localStorage.getItem('totalBuildPrice')) || 0;
       totalBuildPrice += thisPrice;
    console.log('thisPrice',totalBuildPrice);
      localStorage.setItem('totalBuildPrice', totalBuildPrice);
     const priceElement = document.querySelector('.final-build-mrp');
      if (priceElement) {
        priceElement.textContent = totalBuildPrice.toFixed(2);
         priceElement.style.display = 'block';
      }
    console.log('totalPriceValue',totalPriceValue);
    updateSavePrice(totalBuildPrice, totalPriceValue);
    if (!thisId || !thisImage) return;

    if (totalQuantity >= parseInt(restrictSize)) {
      const buildBox = document.querySelector('.cta-build-box');
      if (buildBox) {
        const currentBuildBoxId = buildBox.getAttribute('build-box-id') || '[]';
        const updatedBuildBoxId = JSON.parse(currentBuildBoxId);
        updatedBuildBoxId.push({ id: thisId, quantity: thisQuantity });
        buildBox.setAttribute('build-box-id', JSON.stringify(updatedBuildBoxId));
      }
    }

    const cardParent = this.closest('.box-prod-content');
    if (cardParent) {
      cardParent.classList.add('card-added');
    }

    buildFinalPdpImages?.forEach((imageElement, index) => {
      if (selectedVariants[index]) {
        imageElement.setAttribute("src", selectedVariants[index].image);
        imageElement.classList.remove('d-none');
      } else {
        imageElement.classList.add('d-none');
      }
    });

    buildFinalSpan?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('d-none');
      } else {
        spanElement.classList.remove('d-none');
      }
    });
     buildRemoveSelect?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('d-none');
      } else {
        spanElement.classList.remove('d-none');
      }
    });
        buildRemoveOutline?.forEach((spanElement, index) => {
      if (selectedVariants[index]) {
        spanElement.classList.add('show-bord');
      } else {
        spanElement.classList.remove('show-bord');
      }
    });

    BuildHeader?.forEach((spanElement, index) => {
      const removeBtn = spanElement?.querySelector('.remove-build');
      if (selectedVariants[index]) {
        spanElement.setAttribute("remove-build-id", selectedVariants[index].id);
        spanElement.setAttribute("remove-build-img", selectedVariants[index].image);
        spanElement?.classList.add('assorted-add');
        removeBtn?.classList.remove('d-none');
      } else {
        spanElement.removeAttribute("remove-build-id");
        spanElement.removeAttribute("remove-build-img");
        spanElement?.classList.remove('assorted-add');
        removeBtn?.classList.add('d-none');
      }

      const startIdx = index * restrictSize;
      const endIdx = startIdx + (restrictSize - 1);
      const assortIds = selectedAssortedVariants.slice(startIdx, endIdx)
        .map(variant => variant.id)
        .join(',');

      if (assortIds) {
        spanElement.setAttribute("remove-assort-id", assortIds);
      } else {
        spanElement.removeAttribute("remove-assort-id");
      }
    });

    updateBuildBoxId();
    this.setAttribute('pop-array-id', '');
    idQuantityArray = [];
    const quantityInputs = parentPopup.querySelectorAll('.quantity__input-cstm-assorted');
    quantityInputs.forEach((input, index) => {
      if (index === 0) {
        input.value = 1;
      } else {
        input.value = 0;
      }
    });

    parentPopup.querySelectorAll('.quantity__input-cstm-assorted').forEach((input) => {
      const inputId = input.getAttribute('data-id');
      const inputValue = parseInt(input.value || 0);
      if (inputValue > 0) {
        idQuantityArray.push({ id: inputId, quantity: inputValue });
      }
    });
    if (parentPopup) {
      parentPopup.classList.add('d-none');
      document.body.classList.remove('overflow-cart-hidden');
    }
  });
});
    let isFirstClick = true; 
    assortedQtyBox?.forEach((button) => {
      button.addEventListener('click', function () {
        const parentElement = button.closest('.assorted-popup');
        const assortErr = parentElement.querySelector('.assorted-err');
        const mainBtn = parentElement.querySelector('.assorted-variant-cta');
        const firstElement = mainBtn.getAttribute('pop-cta-id');  
        console.log('pop-cta-id', firstElement);
        const input = button.parentElement.querySelector('.quantity__input-cstm-assorted');
        if (!input) return;
        const step = parseInt(input.getAttribute('step')) || 1;
        const inputId = input.getAttribute('data-id');
        const priceData = input.getAttribute('data-price');
        const assortSize = parseInt(input.getAttribute('assort-size'), 10) || 0;
        console.log('priceData', assortSize);
    
        const previousValue = parseInt(input.value || 0);
        let inputValue = previousValue;
    
        if (button.name === 'plus') {
          inputValue += step; 
        } else if (button.name === 'minus') {
          inputValue = Math.max(0, inputValue - step); 
        }
    
        const totalQuantityWithoutCurrent = idQuantityArray.reduce((sum, item) => {
          if (item.id !== inputId) {
            return sum + item.quantity;
          }
          return sum;
        }, 0);
        
        if (button.name === 'plus') {
          const restrictSize = parseInt(input.getAttribute('assort-size'), 10) || 4; 
          const totalQuantity = totalQuantityWithoutCurrent + inputValue;
          if (totalQuantity > parseInt(assortSize)) {
            if (assortErr) {
              assortErr.classList.remove('d-none');
              setTimeout(() => assortErr.classList.add('d-none'), 3000);
            }
            input.value = previousValue; 
            return;
          }
        }
        input.value = inputValue;
        if (isFirstClick) {
          idQuantityArray.push({ id: firstElement, quantity: 1 });
          isFirstClick = false; 
        }
        const index = idQuantityArray.findIndex(item => item.id === inputId);
        if (index > -1) {
          if (inputValue < 1) {
            idQuantityArray.splice(index, 1);
          } else {
            idQuantityArray[index].quantity = inputValue;
          }
        } else if (inputValue > 0) {
          idQuantityArray.push({ id: inputId, quantity: inputValue });
        }
    
        console.log('Updated idQuantityArray:', idQuantityArray);
    
        let totalPrice = 0;
        idQuantityArray.forEach(item => {
          const price = parseFloat(document.querySelector(`input[data-id="${item.id}"]`).getAttribute('data-price') || 0);
          totalPrice += price * item.quantity;
        });
        const nextCta = this.closest('.assorted-card').querySelector('.assorted-variant-cta');
        if (nextCta) {
          nextCta.setAttribute('pop-array-id', JSON.stringify(idQuantityArray));
          nextCta.setAttribute('assort-prices', totalPrice.toFixed(2));
        }
        console.log('nextCta', nextCta);
      });
});
// end assorted 
  document.body.addEventListener('click', function (event) {
    const clickedElement = event.target;
    if (clickedElement.classList.contains('cta-build-box')) {
      if (selectedVariants.length !== parseInt(sizeBuck)) {
        if (boxNotify) {
          boxNotify.textContent = `Please add ${sizeBuck} products to complete your box.`;
          boxNotify.classList.remove('d-none');
          setTimeout(() => boxNotify.classList.add('d-none'), 3000);
        }
        return;
      }

      const buildIds = JSON.parse(clickedElement.getAttribute('build-box-id')) || [];
       const totalQuantity = buildIds.reduce((sum, item) => sum + item.quantity, 0);  // Calculate total quantity
    const randomNo = Math.floor(Math.random() * 1000);  
      const cartData = buildIds.map(item => ({
        id: item.id,
        quantity: item.quantity,
       properties: { 
        'build-box': 'build-box',
        'max': totalQuantity,  
        'random-no': randomNo  
      },
      }));

      const miniCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!miniCart) return;

      const formData = {
        items: cartData,
        sections: miniCart.getSectionsToRender()?.map(section => section.id) || [],
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
        .then(response => response.ok ? response.json() : Promise.reject('Failed to add items'))
        .then(cartResponse => {
          miniCart.renderContents(cartResponse);
          miniCart.classList.remove('is-empty');
          clickedElement.setAttribute('build-box-id', '');
        })
            .catch((error) => {
        console.error('Error adding to cart:', error);
    })
   .finally(() => {
      localStorage.setItem('selectedVariants', JSON.stringify([]));
      localStorage.setItem('selectedAssortedVariants', JSON.stringify([]));
      localStorage.setItem('totalBuildPrice', JSON.stringify([]));
      selectedVariants = [];
      buildRemoveSpan?.forEach(button => button.classList.add('d-none'));
      buildRemoveSelect?.forEach(button => button.classList.remove('d-none'));
      buildRemoveOutline?.forEach(button => button.classList.remove('show-bord'));
      buildFinalSpan?.forEach(button => button.classList.remove('d-none'));
     // freeBoxElement?.classList.add('d-none');
       // boxSample?.classList.add('d-none');
       localStorage.removeItem('freeBox');
      BuildHeader?.forEach(element => {
      element.removeAttribute('remove-build-id');
      element.removeAttribute('remove-build-img');
    });
   buildFinalPdpImages?.forEach(img => {
      img.setAttribute('src', '');
      img.classList.add('d-none'); 
    });  
   const priceElement = document.querySelector('.final-build-mrp');
      if (priceElement) {
         priceElement.textContent = '';
      priceElement.style.display = 'none';  
    } 
     startTimer();
   });
    }
  });
    updateBuildBoxId();
  updateFinalPrice();
  updateSavePrice(totalBuildPrice, totalPriceValue);
});

  document.addEventListener('DOMContentLoaded', function () {
  const gliders = document.querySelectorAll('.glider');
  gliders.forEach(function (gliderElement) {
    new Glider(gliderElement, {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      arrows: {
        prev: gliderElement.closest('.glider-container').querySelector('.glider-prev'),
        next: gliderElement.closest('.glider-container').querySelector('.glider-next')
      }
    });
  });
 document.querySelectorAll('.learn-build').forEach(svg => {
  svg.addEventListener('click', function (event) {
    event.stopPropagation(); 
    document.querySelectorAll('.learn-box').forEach(box => {
      box.classList.remove('slide-in');
      box.classList.add('slide-out'); 
    });
    const learnBox = this.closest('.box-product-card')?.querySelector('.learn-box');
    if (learnBox) {
      learnBox.classList.remove('slide-out'); 
      learnBox.classList.add('slide-in');
      const handleOutsideClick = (e) => {
        if (!e.target.closest('.slider-learn-boes')) {
          learnBox.classList.remove('slide-in'); 
          learnBox.classList.add('slide-out'); 
          document.removeEventListener('click', handleOutsideClick);
        }
      };

      document.addEventListener('click', handleOutsideClick);
    }
  });
});
document.addEventListener('click', function (event) {
  const crossBtn = event.target.closest('.build-ingredientclose');
  const button = event.target.closest('.learn-box button');
  if (button) {
    const productCTA = button.closest('.box-product-card')?.querySelector('.product-varaints-cta');
    if (productCTA) {
      productCTA.click();
    }
    const learnBox = button.closest('.learn-box');
    if (learnBox) {
    learnBox.classList.remove('slide-in'); 
          learnBox.classList.add('slide-out'); ;
    }
  }
  if (crossBtn) {
      const learnBox = crossBtn.closest('.learn-box');
    if (learnBox) {
    learnBox.classList.remove('slide-in'); 
          learnBox.classList.add('slide-out');  
    }
  }
});  
});